import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    width: '100%',
    paddingTop: '3.5rem',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingBottom: '2.5rem',

    backgroundColor: theme.colors.backgroundsSecondary,

    min1024: {
        overflow: 'auto',
        paddingRight: '2.5rem',
    },
});

export const tabContainer: TRuleWithTheme = ({ theme }) => ({
    width: '100%',
    height: '100%',

    display: 'flex',
});
